<template>
  <div class="PersonalCenter">
    <Poptip
      trigger="hover"
      width="335"
      placement="bottom-end"
      :offset="20"
    >
      <!-- 嵌套最外层 -->
      <div
        slot="content"
        class="outboard-box"
      >
        <!-- 嵌套内部个人中心 -->
        <div class="head-personal">
          <Poptip
            trigger="hover"
            content="content"
            placement="bottom-end"
            :offset="15"
            width="150"
          >
            <span class="head-personal-span">
              <div class="personal-text">个人中心</div>
              <i class="el-icon-arrow-right personal-icon personal-icon"></i>
            </span>
            <div slot="content">
              <div>
                <div
                  class="info-content-item"
                  v-for="(item,index) in infoList"
                  @click="infoItme(index)"
                >
                  <div class="info-content-item-img">
                    <img :src="item.icon">
                  </div>
                  <div class="info-content-item-text">{{item.name}}</div>
                </div>
              </div>
            </div>
          </Poptip>
        </div>
        <!-- 嵌套内部头像 -->
        <div class="info">
          <div class="info-head">
            <img
              :src="userinfo.avatar ? userinfo.avatar : require('../../assets/image/avatar.png') "
            />
          </div>
          <div class="info-name">{{userinfo.username}}</div>
        </div>
        <!-- 关注、退出登录 -->
        <div class="interest-quit-box">
          <!-- 合集 -->
          <div class="interest-quit">
            <div class="interest-quit-img">
              <img src="../../assets/image/PersonalCenter/heiji.png">
            </div>
            <div
              class="interest-quit-text"
              @click="($router.push('/collection'))"
            >我的合集</div>
          </div>
          <div style="height: 20px; border-bottom: 1px solid #f2f6f9;"></div>
          <!-- 关注     -->
          <Poptip
            trigger="hover"
            width="155"
            placement="bottom-end"
            :offset="-50"
          >
            <div
              slot="content"
              class="follow-with-interest-box"
            >
              <div
                class="follow-with-interest-box-item"
                v-for="(item,index) in follow"
                @click="followClick(index)"
              >
                <span><img :src="item.img"></span>
                <span>{{item.name}}</span>
              </div>
            </div>
            <div class="interest-quit-guanzhu">
              <div class="interest-quit-guanzhu-img">
                <img
                  src="../../assets/image/PersonalCenter/follow_with_interest.png"
                >
              </div>
              <div class="interest-quit-guanzhu-text">我的关注</div>
            </div>
          </Poptip>
          <div style="height: 20px"></div>
          <!-- 退出 -->
          <div class="interest-quit">
            <div class="interest-quit-img">
              <img src="../../assets/image/PersonalCenter/quit.png">
            </div>
            <div
              class="interest-quit-text"
              @click="dialogVisible=true"
            >退出登录</div>
          </div>
        </div>

      </div>
      <!-- 嵌套最外层  结束-->

      <!-- 鼠标经过最外部 开始  头像-->
      <span class="head-hover">
        <div class="sculptureHove">
          <span>{{userinfo.username}}</span>
          <div class="header_pictor">
            <img
              :src="userinfo.avatar ? userinfo.avatar : require('../../assets/image/avatar.png') "
            />
          </div>
        </div>
      </span>
      <!-- 鼠标经过最外部 结束 -->
    </Poptip>

    <!-- 确定退出提示框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="25%"
    >
      <span>确定退出吗？</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="exitcode"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { follow } from '../../utils/classfiy'
export default {
  name: 'PersonalCenter',
  data () {
    return {
      interestQuitList: [
        {
          icon: require('../../assets/image/PersonalCenter/follow_with_interest.png'),
          name: '我的关注'
        },
        {
          icon: require('../../assets/image/PersonalCenter/quit.png'),
          name: '退出登录'
        }
      ],
      infoList: [
        {
          icon: require('../../assets/image/PersonalCenter/ziliao.png'),
          name: '我的资料'
        },
        {
          icon: require('../../assets/image/PersonalCenter/mima.png'),
          name: '修改密码'
        },
        {
          icon: require('../../assets/image/PersonalCenter/shouji.png'),
          name: '修改手机'
        },
        {
          icon: require('../../assets/image/PersonalCenter/bingli.png'),
          name: '我的病例'
        },
      ],
      follow: [],
      userinfo: {},
      visible: false,
      dialogVisible: false,
    }
  },
  created () {
    this.follow = follow
    // this.getMe()
  },
  watch: {
    $route: {
      handler: function (to, form) {
        //当没有token的时候不请求个人信息接口
        if (window.localStorage.getItem('token')) this.getMe()
      },
      // 深度观察监听 
      deep: true,
      immediate: true
    }
  },
  methods: {
    //获取个人信息
    async getMe () {
      const { data: data } = await this.$http.post('me')
      this.userinfo = data.data
      localStorage.setItem("userinfo", JSON.stringify(data.data))
      if (data.data.userTypeId == 0) {
        this.$router.push('/improveInfo')
        return
      }
      localStorage.removeItem("code"); //!需要 等会解开  
    },
    interestQuit (i) {
      console.log(i);
    },
    //个人资料点击跳转页面
    infoItme (i) {
      if (i == 0) this.$router.push({ name: 'datum' })
      if (i == 1) this.$router.push({ name: 'changePassword' })
      if (i == 2) this.$router.push({ name: 'changePhone' })
      if (i == 3) this.$router.push({ name: 'caseAll' })
    },
    //我的关注
    followClick (i) {
      this.$router.push({
        path: '/myConcerns',
        query: {
          index: i + 1
        }
      })
    },
    //退出 
    exitcode () {
      //localStorage   
      localStorage.removeItem("token");
      localStorage.removeItem("userinfo");
      // localStorage.removeItem("code"); 
      this.$router.replace('/login')
      this.dialogVisible = false
    },
  }
}

</script>
<style lang="less" scoped>
.PersonalCenter {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  /deep/ .ivu-poptip-body {
    padding: 0;
  }

  /deep/ .ivu-poptip-body-content {
    overflow: visible;
  }

  .head-hover {
    cursor: pointer;
    .sculptureHove {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 16px;
        color: #484c7f;
      }
      .header_pictor {
        width: 49px;
        height: 49px;
        border-radius: 50%;
        overflow: hidden;
        margin-left: 8px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  //第一层盒子内容
  .outboard-box {
    padding: 15px 22px;
    position: relative;
    .head-personal {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 5px;
      color: #b5b8c2;
      z-index: 999999;
      .head-personal-span {
        display: flex;
        align-items: center;
        &:hover {
          cursor: pointer;
          color: #484c7f;
        }
        .personal-text {
          padding-right: 3px;
        }
      }
    }

    .info {
      position: relative;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f2f6f9;
      .info-head {
        position: relative;
        top: -10px;
        left: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 10px;
        margin-bottom: 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info-name {
        position: relative;
        top: -10px;
        left: 0;
        font-size: 16px;
        color: #484c7f;
      }
    }

    .interest-quit-box {
      width: 100%;
      .interest-quit {
        position: relative;
        display: flex;
        align-items: center;
        padding: 20px 0 5px 0;
        border-top: 1px solid #f2f6f9;
        .interest-quit-img {
          width: 14px;
          height: 14px;
          position: relative;
          top: -2px;
          left: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .interest-quit-text {
          font-size: 16px;
          color: #212529;
          padding-left: 5px;
          &:hover {
            cursor: pointer;
            color: #484c7f;
          }
        }
      }

      .interest-quit-guanzhu {
        position: relative;
        width: 291px;
        display: flex;
        align-items: center;
        cursor: pointer;
        // margin: 20px 0;
        margin-top: 20px;
        ::after {
          content: "";
          width: 10px;
          height: 15px;
          background: url("../../assets/image/lower.png") no-repeat center;
          position: absolute;
          top: 4px;
          right: 0;
        }

        .interest-quit-guanzhu-text {
          font-size: 16px;
          color: #212529;
          padding-left: 5px;
        }
      }

      //我的关注
      .follow-with-interest-box {
        padding: 20px 30px;

        .follow-with-interest-box-item {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #212529;
          margin-bottom: 30px;

          :nth-child(1) {
            width: 14px;
            height: 14px;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          :hover {
            cursor: pointer;
            color: #484c7f;
          }
        }
        .follow-with-interest-box-item:last-child {
          margin-bottom: 0;
        }
      }
    }

    .info-content-item {
      display: flex;
      align-items: center;
      padding: 15px 20px;
      color: #b5b8c2;
      .info-content-item-img {
        width: 10px;
        img {
          width: 100%;
        }
      }
      .info-content-item-text {
        margin-left: 5px;
        font-size: 13px;
      }
      &:last-child {
        margin-bottom: 0px;
      }
      &:hover {
        cursor: pointer;
        color: #484c7f;
      }
    }
  }
}
</style>